<!--年报
以天为单位，单个设备，显示整点值
-->
<template>
	<div class="yearPowerQualityBody">
		<!--日期弹窗-->
		<datePicker ref="datePicker" :initDate='nowSelectDate' @selectYear="selectDate" type="year"></datePicker>
		<!--<virtualDeviceTree slot="tree" :dataList="virtualDeviceList" @checkItem="nowVirtualDevice = $event"></virtualDeviceTree>-->
		<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowVirtualDevice = $event"></elRadioTree>
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<multipleSelection title="应用类型组" nameKey="name" :list='apptypeGroups' @checkDataList="nowApptypeGroups = $event"
				 :autoCheckIdList="[6]" @checkIdList="$store.cacheStore.commit('setNowSelectAppTypeGroupIds',$event)"></multipleSelection>
				<!--日期-->
				<iconButton icoName="wedoButton/date.png" :buttonText="nowDateText" @buttonClick="$refs.datePicker.show()"></iconButton>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
			</div>
			<!--图表-->
			<vchart ref='vchart' style="height: calc(100% - 2.37rem);"></vchart>
			<!--表格显示数据-->
			<infoList ref="infoList" style="height: 2rem;" :columns='columns' :dataList="nowPage" :pageLen='pageLen'
			 :totalSize="nowShowDataList.length" @selectPage="nowIndex = $event" :dataType='1' :fillAll="true"></infoList>
		</div>
	</div>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			treeBody,
			datePicker,
			virtualDeviceTree,
			iconButton,
			multipleSelection,
			vchart,
			infoList,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				nowVirtualDevice: undefined,
				nowApptypeGroups: [],
				dataObject: {},
				totalSize: 0,
				nowIndex: 0,
				options: {},
				from2name:{}
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.toolbox['iconStyle']={
				'color':'white',
				'borderColor':'white',
				'shadowColor':'white'
			}
			
			this.$refs.vchart.setData(this.options, true)
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowSelectDate() {
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			virtualDeviceList() {
				var appTypeNos = this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
				return [deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(appTypeNos.join(','), this.nowUnit.id))]
			},
			nowDateText() {
				return this.nowSelectDate.getFullYear() + '年'
			},
			variableTree() {
				if (this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = []
				for (var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
					var item = this.nowApptypeGroups[i]
					if (item.id == -1 || item.id == -2) {
						ag = ag.concat(item.next.map(ni => {
							return ni.id
						}))
					} else {
						ag.push(item.id)
					}
				}
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.no)
				})
				if (isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						v2.push(i.fromName)//fromName
					})
				})
				return v2
			},
			apptypeGroups() {
				return this.$store.variableStore.state.powerApptypeGroup
			},
			nowShowDataList() {
				//当前应该显示的数据列表
				var list = []
				//只取出要显示的变量的数据
				for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
					var item = {}
					item.data = this.dataObject[this.nowVariableNames[i]]
					if (!isempty(item)) {
						item.name = this.nowVariableNames[i]
						list.push(item)
					}
				}
				return list
			},
			columns() {
				//列表的项，每个整点值
				var list = []
				list.push({
					name: "名称",
					weight:1.5
				})
				for (var i = 1; i < 13; i++) {
					list.push({
						name: i + '月'
					})
				}
				return list
			},
			nowPage() {
				//按照页码来返回当前应该显示的列表
				var list = []
				var baseList = this.nowShowDataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				//排练数据，名称在第一个，后面按顺序显示数据
				for (var i = 0, len = baseList.length; i < len; i++) {
					var item = baseList[i]
					var vlist = []
					vlist.push(item.name.subByFirstChar('.'))
					var datalist = item.data //XXX三相电流.12个月份的数据   格式见 : nowShowDataList
					let monthlist = []
					for (let month of datalist) { //插入当前variableName 的 每月的平均值
						if (isempty(month)) { //月数据为空
							monthlist.push(undefined)
						} else { //月
							if (!isnull(month.avg)) { //有平均值时 直接插入
								monthlist.push(month.avg)
							} else { //否则自己算data
								let sum = 0;
								let count = 0;
								month.data.forEach(value => {
									if (!isnull(value)) {
										//只计算有效值
										sum += value
										count++
									}
								})
								if (count == 0) {
									//一个有效值都没有
									monthlist.push(undefined)
								} else {
									monthlist.push(cutDigital(sum / count))
								}
							}
						}
					}
					vlist = vlist.concat(monthlist)
					list.push(vlist)
				}
				return list
			},
			allVariableName() {
				//所有的通讯变量名称
				var list = []
				for (var i = 0, len = this.variableTree.length; i < len; i++) {
					var next = this.variableTree[i].next
					for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
						var item = next[i2]
						this.from2name[item.fromName] = item.name
						list.push(item.fromName)//fromName
					}
				}
				return list
			},
			pageLen() {
				return this.nowVariableNames.length < 6 ? 6 : this.nowVariableNames.length
			}
		},
		watch: {
			nowDevice(nv, ov) {
				this.dataObject = []
			},
			nowShowDataList(nv, ov) {
				//获取到新的数据了，重新渲染
				this.reloadChart(nv)
				this.nowIndex = 0
			},
			allVariableName(nv, ov) {
				this.search()
			},
			nowSelectDate(nv, ov) {
				this.search()
			}
		},
		methods: {
			selectDate(date) {
				this.$store.cacheStore.commit("setNowSelectDate", date)
				this.$refs.datePicker.hide()
			},
			search() {
				if (isempty(this.virtualDeviceList)) {
					return
				}
				if (this.nowVirtualDevice == undefined) {
					this.$dialogMethod.showMessage('请先选中设备！')
					return
				}
				if (isempty(this.allVariableName)) {
					return
				}
				this.$dialogMethod.showLoading('数据正在加载...')
				//查询数据
				this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','), 'year', this.nowSelectDate.getTime(),
					respon => {
						//补上缺失数据
						var keys = Object.keys(respon)
						for (var i = 0, len = keys.length; i < len; i++) {
							var key = keys[i]
							var list = respon[key]
							list.forEach(item => {
								if (item.data == undefined) {
									item.data = []
									item.variablename = key
									item.avg = -1.1111
									item.max = -1.1111
									item.min = -1.1111
									item.next = -1.1111
								}
							})
						}
						this.dataObject = respon
						this.$dialogMethod.closeLoading()
					})
			},
			exportExcel() {

			},
			reloadChart(list) {
				var selected = {}
				var legend = []
				var seriesList = []
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					var name = this.from2name[item.name]?this.from2name[item.name]: item.name//list 设置为 name 
					
					
					name = name.subByFirstChar(".")

					var datalist = item.data //12个月份的数据 [{1月},{2月}]   月份数据都在next里面
					let monthlist = []
					var vlist = []
					for (var i2 = 0, len2 = datalist.length; i2 < len2; i2++) { //插入每月的平均值
						var month = datalist[i2]
						var monthAvg = undefined
						if (isempty(month)) {} else {
							if (!isnull(month.avg)) { //有平均值时 直接插入
								monthAvg = month.avg
							} else { //否则自己算data
								let sum = 0;
								let count = 0;
								month.data.forEach(value => {
									if (!isnull(value)) {
										//只计算有效值
										sum += value
										count++
									}
								})
								if (count == 0) {
									//一个有效值都没有
								}
								monthAvg = cutDigital(sum / count)

							}
						}

						vlist.push([i2 + 1 + '月', monthAvg])
					}
					seriesList.push({
						name: name,
						fromName: item.name,
						type: 'line',
						smooth: true,
						symbol: 'none',
						sampling: 'average',
						data: vlist,
					})
					selected[name] = i < 6 ? true : false
					legend.push({
						name: name,
						icon: 'roundRect'
					})
				}
				this.options.series = seriesList
				this.options.legend.data = legend
				this.options.legend.selected = selected
				this.options.title.text = this.nowVirtualDevice.name+this.nowSelectDate.getFullYear() + '年电能质量'
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	.monthReportBody {
		width: 100%;
		height: 100%;
		display: flex;
	}

	.monreportLeft {
		height: 99%;
	}

	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.tableData {
		width: 100%;
	}

	.tableData tr:nth-child(1) td {
		text-align: center;
		border: .01rem solid;
		margin-top: .1rem;
	}
	.yearPowerQualityBody{
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;

	}
</style>
